export enum ProxyNotificationType {
  CREATE_PROXY = 'CREATE_PROXY',
  CREATE_TM = 'CREATE_TM',
  REMOVE_PROXY = 'REMOVE_PROXY',
  REMOVE_TM = 'REMOVE_TM',
  NONE = 'NONE',
}

export class ProxyNotification {
  userID: string;

  relation: string;

  direction: string;

  relatedUserID: string;

  relatedUsername: string;

  lastUpdatedTime: string;

  type: ProxyNotificationType;

  constructor({
    userID,
    relation,
    direction,
    relatedUserID,
    relatedUsername,
    lastUpdatedTime,
    type,
  }: Record<string, any>) {
    this.userID = userID;
    this.relation = relation;
    this.direction = direction;
    this.relatedUserID = relatedUserID;
    this.relatedUsername = relatedUsername;
    this.lastUpdatedTime = lastUpdatedTime;
    this.type = type;
  }
}

export const EmptyProxyNotification: ProxyNotification = {
  userID: '',
  relation: '',
  direction: '',
  relatedUserID: '',
  relatedUsername: '',
  lastUpdatedTime: '',
  type: ProxyNotificationType.NONE,
};
